module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_2_04-902bda5d7a4bdda245f6dedb752fc8c5.jpg";